export default __webpack_public_path__ + "static/media/iPhones.e0705063.png";